// export default function SwitchToggle({ checked, onChange,defaultRegion }) {
//     return (
//         <label className="custom-switch">
//             <input
//                 type="checkbox"
//                 checked={checked}
//                 onChange={onChange}
//                 disabled={!defaultRegion}
//             />
//             <span className="slider"></span>
//         </label>
//     );
// }

export default function SwitchToggle({ checked = false, onChange }) {
    return (
      <label className="custom-switch">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
        //   disabled={!defaultRegion}
        />
        <span className="slider"></span>
      </label>
    );
  }